export default {
  pt: {
    'acoesEmMassa.botao': 'Ações em massa',
    'acoesEmMassa.titulo': 'Ações em massa',
    'acoesEmMassa.contrato': 'Contrato',
    'acoesEmMassa.etapa.acao': 'Ação',
    'acoesEmMassa.escolhaTitulo': 'O que você quer fazer com as viagens desta frente?',
    'acoesEmMassa.escolhaDica': 'Escolha uma ação. As próximas etapas seguem a ação escolhida.',
    'acoesEmMassa.continuar': 'Continuar',
    'acoesEmMassa.voltar': 'Voltar',
    'acoesEmMassa.cancelar': 'Cancelar',
    'acoesEmMassa.descartarTitulo': 'Descartar as alterações?',
    'acoesEmMassa.descartarMensagem': 'O que você ajustou ainda não foi aplicado e será perdido.',
    'acoesEmMassa.descartar': 'Descartar',
    'acoesEmMassa.reagendamento.titulo': 'Reagendar viagens',
    'acoesEmMassa.reagendamento.descricao': 'Mude o início de várias viagens de uma vez, todas juntas ou uma a uma, e reorganize os motoristas entre elas.',
    'acoesEmMassa.reagendamento.etapa.selecao': 'Viagens',
    'acoesEmMassa.reagendamento.etapa.ajustes': 'Ajustes',
    'acoesEmMassa.reagendamento.etapa.revisao': 'Revisão',
  },
  en: {
    'acoesEmMassa.botao': 'Bulk actions',
    'acoesEmMassa.titulo': 'Bulk actions',
    'acoesEmMassa.contrato': 'Contract',
    'acoesEmMassa.etapa.acao': 'Action',
    'acoesEmMassa.escolhaTitulo': 'What do you want to do with the trips of this work front?',
    'acoesEmMassa.escolhaDica': 'Choose an action. The next steps follow the chosen action.',
    'acoesEmMassa.continuar': 'Continue',
    'acoesEmMassa.voltar': 'Back',
    'acoesEmMassa.cancelar': 'Cancel',
    'acoesEmMassa.descartarTitulo': 'Discard the changes?',
    'acoesEmMassa.descartarMensagem': 'What you adjusted has not been applied yet and will be lost.',
    'acoesEmMassa.descartar': 'Discard',
    'acoesEmMassa.reagendamento.titulo': 'Reschedule trips',
    'acoesEmMassa.reagendamento.descricao': 'Change the start of several trips at once, all together or one by one, and reorganize the drivers among them.',
    'acoesEmMassa.reagendamento.etapa.selecao': 'Trips',
    'acoesEmMassa.reagendamento.etapa.ajustes': 'Adjustments',
    'acoesEmMassa.reagendamento.etapa.revisao': 'Review',
  },
  es: {
    'acoesEmMassa.botao': 'Acciones en lote',
    'acoesEmMassa.titulo': 'Acciones en lote',
    'acoesEmMassa.contrato': 'Contrato',
    'acoesEmMassa.etapa.acao': 'Acción',
    'acoesEmMassa.escolhaTitulo': '¿Qué quiere hacer con los viajes de este frente?',
    'acoesEmMassa.escolhaDica': 'Elija una acción. Los próximos pasos siguen la acción elegida.',
    'acoesEmMassa.continuar': 'Continuar',
    'acoesEmMassa.voltar': 'Volver',
    'acoesEmMassa.cancelar': 'Cancelar',
    'acoesEmMassa.descartarTitulo': '¿Descartar los cambios?',
    'acoesEmMassa.descartarMensagem': 'Lo que ajustó aún no se aplicó y se perderá.',
    'acoesEmMassa.descartar': 'Descartar',
    'acoesEmMassa.reagendamento.titulo': 'Reprogramar viajes',
    'acoesEmMassa.reagendamento.descricao': 'Cambie el inicio de varios viajes a la vez, todos juntos o uno por uno, y reorganice los conductores entre ellos.',
    'acoesEmMassa.reagendamento.etapa.selecao': 'Viajes',
    'acoesEmMassa.reagendamento.etapa.ajustes': 'Ajustes',
    'acoesEmMassa.reagendamento.etapa.revisao': 'Revisión',
  },
}
